import {createGlobalStyle} from 'styled-components';

/**
 * Global theme independent styling used across the whole application can be put here.
 * @type {GlobalStyleComponent<{}, DefaultTheme>}
 */
export const GlobalStyles = createGlobalStyle`
    
`;